<template>
  <v-dialog
    v-model="showDialog"
    max-width="900"
    @click:outside="cancelDialog"
    content-class="whitelist-dialog"
  >
    <v-card>
      <v-card-title>
        <h3>Whitelist</h3>
      </v-card-title>

      <v-card-text class="content">
        <v-icon id="spinner" medium center v-if="loading"
          >fas fa-spinner fa-spin</v-icon
        >
        <v-data-table
          v-if="!loading"
          :headers="headers"
          :items="IPs"
          class="elevation-1"
          no-data-text="There are no whitelisted IPs."
          :items-per-page="5"
          :loading="deleteLoading"
        >
          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-3" @click.self="deleteRecord(item.CidrIp)"
              >far fa-trash-alt</v-icon
            >
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions class="justify-center buttons">
        <v-btn text @click="cancelDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    headers: [
      {
        text: "IP address",
        align: "start",
        sortable: false,
        value: "CidrIp",
      },
      {
        text: "Owner",
        align: "start",
        sortable: true,
        value: "Owner",
      },
      {
        text: "Action",
        align: "end",
        sortable: false,
        value: "action",
      },
    ],
    IPs: [],
    loading: false,
    deleteLoading: false,
  }),
  props: ["showWhitelistDialog", "environmentId", "keyPairName", "OS", "environments"],
  watch: {
    async showWhitelistDialog() {
      const { showWhitelistDialog } = this;

      if (showWhitelistDialog) {
        await this.loadIPs();
      }
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.showWhitelistDialog;
      },
      set(value) {
        this.$emit("update:showWhitelistDialog", value);
      },
    },
  },
  methods: {
    ...mapActions([
      "showSnackbar",
      "getWhitelistedIPs",
      "deleteWhitelistedIP",
    ]),
    cancelDialog() {
      this.showDialog = false;
    },
    async deleteRecord(CidrIp) {
      this.deleteLoading = true;
      if (!this.environments) {
        const id = this.$route.params.id;
        const data = { id, CidrIp };

        const { error } = await this.deleteWhitelistedIP(data);

        if (!error) {
          this.IPs = this.IPs.filter((ip) => ip.CidrIp != CidrIp);
        }
      } else {
        console.log(this.environments)
        await Promise.all(
          this.environments.map(
            async (env) =>
              await this.deleteWhitelistedIP({ id: env.EnvironmentId, CidrIp })
          )
        );
        this.IPs = this.IPs.filter((ip) => ip.CidrIp != CidrIp);
      }

      this.deleteLoading = false;
    },
    async loadIPs() {
      const { OS } = this;
      if (OS === "Linux" || OS === "Windows") {
        this.loading = true;
        this.IPs = await this.getWhitelistedIPs(this.environmentId);

        // we need to do this in that way, bc data table is a little bugged
        if (this.IPs === null) {
          this.IPs = [];
        }
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.whitelist-dialog h3,
p {
  font-family: "Montserrat";
  text-align: center;
}

.whitelist-dialog h3 {
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
}

.whitelist-dialog p {
  font-weight: 500;
}

.whitelist-dialog .content {
  text-align: center;
}
.whitelist-dialog .buttons {
  padding-bottom: 60px;
}

.buttons {
  font: 12px/15px "Montserrat";
}

#spinner {
  margin: 0 auto;
}
</style>